var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.578 14.96h13.07c1.399 0 2.22-.812 2.22-2.42V4.515c0-1.61-.829-2.422-2.454-2.422h-7.5c-.531 0-.851-.125-1.242-.461l-.477-.39C5.68.804 5.281.663 4.508.663H2.28C.914.664.125 1.445.125 3.016v9.523q.002 2.424 2.453 2.422M1.383 3.087c0-.773.406-1.172 1.156-1.172h1.648c.516 0 .829.133 1.227.469l.477.398c.507.422.922.57 1.695.57h7.805c.773 0 1.218.422 1.218 1.235v.445H1.383zm1.21 10.617c-.78 0-1.21-.414-1.21-1.226V6.21h15.226v6.273c0 .805-.445 1.22-1.218 1.22z"
  })));
};
export default SvgFolder;